import { makeStyles } from "@material-ui/core/styles";

// FASE 0: Usar agendaTheme del tema global (0257)
const getAgenda = (theme) => theme.agenda || { palette: {}, typography: {}, spacing: { md: 16 }, shape: { borderRadius: 8 } };

export const useStyles = makeStyles((theme) => {
  const a = getAgenda(theme);
  const spacing = a.spacing || { md: 16, sm: 8 };
  const palette = a.palette || {};
  const shape = a.shape || { borderRadius: 8 };
  const shadows = a.shadows || {};

  return {
    pageRoot: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      minHeight: 0,
      overflow: "hidden"
    },
    contentScroll: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
      paddingBottom: theme.spacing(2)
    },
    // Tabs (FASE 1)
    tabs: {
      flexShrink: 0,
      marginBottom: theme.spacing(1),
      borderBottom: `1px solid ${palette.border || theme.palette.divider}`
    },
    tab: { textTransform: "none", fontWeight: 600, minWidth: 100 },
    badge: { marginLeft: theme.spacing(0.5), fontSize: "0.75rem" },
    // Configuración
    configLayout: { display: "flex", gap: theme.spacing(3), marginTop: theme.spacing(2) },
    configSubmenu: { width: 200, flexShrink: 0 },
    configSubmenuItem: {
      borderRadius: shape.borderRadiusSm,
      marginBottom: theme.spacing(0.5),
      "&.Mui-selected": { backgroundColor: palette.primary ? `${palette.primary}15` : undefined }
    },
    configContent: { flex: 1 },
    configCard: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`,
      backgroundColor: palette.card || "#ffffff",
      "&:hover": { boxShadow: shadows.cardHover || "0 4px 6px -1px rgba(0, 0, 0, 0.1)" }
    },
    configCardTitle: {
      fontSize: (a.typography && a.typography.h4 && a.typography.h4.fontSize) || "1.125rem",
      fontWeight: 600,
      marginBottom: theme.spacing(1)
    },
    configCardDesc: {
      fontSize: (a.typography && a.typography.body2 && a.typography.body2.fontSize) || "0.875rem",
      color: palette.textSecondary || "#6b7280",
      marginBottom: theme.spacing(2)
    },
    configCardActions: { display: "flex", justifyContent: "flex-end" },
    configProfileBanner: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: shape.borderRadius,
      backgroundColor: palette.background || "#f9fafb",
      border: `1px solid ${palette.border || "#e5e7eb"}`
    },
    configFirstTimeBanner: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: shape.borderRadius,
      backgroundColor: palette.primary ? `${palette.primary}08` : "#eff6ff",
      border: `1px dashed ${palette.primary || "#1e3a8a"}`
    },
    // Dashboard (FASE 2)
    dashboardKpi: {
      padding: theme.spacing(2),
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`
    },
    dashboardChart: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(2),
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`
    },
    dashboardToday: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(2),
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`
    },
    dashboardTodayItem: {
      padding: theme.spacing(1.5, 0),
      borderBottom: `1px solid ${palette.border || "#e5e7eb"}`,
      "&:last-child": { borderBottom: "none" }
    },
    // Pendientes cards (FASE 2)
    pendientesCard: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`,
      "&:hover": { boxShadow: shadows.cardHover || "0 4px 6px -1px rgba(0, 0, 0, 0.1)" }
    },
    pendientesCardActions: { display: "flex", gap: theme.spacing(1), marginTop: theme.spacing(1), flexWrap: "wrap" },
    viewToggle: { marginRight: theme.spacing(2) },
    boardPaper: {
      marginTop: theme.spacing(2),
      overflow: "auto",
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      "&:hover": { boxShadow: shadows.cardHover || "0 4px 6px -1px rgba(0, 0, 0, 0.1)" }
    },
    calendarWrap: {
      height: "min(680px, calc(100vh - 250px))",
      minHeight: 460,
      marginTop: theme.spacing(2),
      borderRadius: shape.borderRadius,
      overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        height: "calc(100vh - 230px)",
        minHeight: 420
      }
    },
    calendarEvent: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      fontFamily: (a.typography && a.typography.fontFamily) || theme.typography.fontFamily
    },
    // Historial (0260)
    historialTableWrap: {
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`,
      overflow: "auto",
      maxHeight: "calc(100vh - 320px)"
    },
    historialTh: {
      fontWeight: 600,
      backgroundColor: palette.background || "#f9fafb",
      borderBottom: `1px solid ${palette.border || "#e5e7eb"}`
    },
    historialRow: {
      "&:hover": { backgroundColor: palette.hover || "rgba(0,0,0,0.04)" }
    },
    historialCard: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1.5),
      borderRadius: shape.borderRadius,
      boxShadow: shadows.card || "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      border: `1px solid ${palette.border || "#e5e7eb"}`
    }
  };
});
